import React from 'react';
import PropTypes from 'prop-types';

const MriIntegrationInfo = ({ integration: { vendor, mri_community_id, partner_key, client_id, database_name, url, username, password } }) => (
  <div className="knock-admin-integration-info">
    <div>
      <strong>Integration:</strong> {vendor}
    </div>
    <div>
      <strong>MRI property ID:</strong> {mri_community_id}
    </div>
    <div>
      <strong>Partner Key:</strong> {partner_key}
    </div>
    <div>
      <strong>Client ID:</strong> {client_id}
    </div>
    <div>
      <strong>Database Name:</strong> {database_name}
    </div>
    <div>
      <strong>URL:</strong> {url}
    </div>
    <div>
      <strong>Username:</strong> {username}
    </div>
    <div>
      <strong>Password:</strong> {password}
    </div>
  </div>
);

MriIntegrationInfo.propTypes = {
  integration: PropTypes.object
};

export default MriIntegrationInfo;
